import { render, staticRenderFns } from "./create-case-label.vue?vue&type=template&id=8cd209d2&"
import script from "./create-case-label.vue?vue&type=script&lang=ts&"
export * from "./create-case-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports